import {
  CreateJobCatalogTreeNodeDocument,
  CreateJobCatalogTreeNodeMutation,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(CreateJobCatalogTreeNodeDocument, {
    extractorFn: (data: CreateJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.createJobcatalogTreeNode,
  })

  const createNode = (
    companyId: string,
    description: string,
    name: string,
    nodeType: string,
    parentId: string, // TODO: Remove this when the mutation query is updated to use nodeUuid
    parentNodeUuid: string
  ) => {
    return mutate({
      variables: {
        companyId,
        description,
        name,
        nodeType,
        parentId,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid: parentNodeUuid,
            childType: nodeType,
          },
        },
      ],
    })
  }

  return { createNode, loading }
}

export default useCreateJobCatalogTreeNode
